import { signout } from "../session";
import { ApiAuthError } from "./errors";
import { toast } from "../toast";
export var errorHandler = function errorHandler(history) {
  return function (err) {
    toast.error(err.message);
    if (err instanceof ApiAuthError) {
      console.log('服务端鉴权失败，清理session');
      signout(history);
    }
  };
};